<template>
  <section class="sec sec-01" id="home" ref="home">
    <div class="hexagon-bkg">
        <img class="hidden  base-img1" src="/theme/img/hexagon-group.svg" />
         <img class="hidden  base-img2" src="/theme/img/hexagon-mob.svg" />
      <hexS1></hexS1>
    </div>
    <div class="layer1">
      <div class="container">
        <h1 class="l1tl1 wow fadeInUp"  data-wow-duration="1s" data-wow-delay="1.5s" v-html="title"></h1>
        <h3 class="l1tl2 wow fadeInUp" data-wow-duration="1s" data-wow-delay="1.7s" v-html="titleSub"></h3>
        <div class="subbox text-center">
          <p class="wow fadeInDown"  data-wow-duration="1s" data-wow-delay="1.7s">
            Join our community of early adopters be the lucky ones to get<br>
            2-months of free algo trading experience
          </p>
          <div class="box-con wow fadeInUp"  data-wow-duration="1s" data-wow-delay="2s">
            <div class="neo-form-box">
              <div class="row">
                <div class="col-lg-8">
                  <div class="input-box">
                    <input  type="email" class="neo-input" placeholder="Enter Your Email Address" id="userEmail" v-model="userEmail"/>
                    <p class="info" v-html="formMessage"></p>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="input-box">
                    <button class="neo-input" type="submit" @click="submitUserEmail()">Get Early Access</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import helpers from '@/plugins/helpers' 
import axios from 'axios'
import hexS1 from './hexagons/hsec1'

export default {
  components: {
    hexS1
  },
  props: {
      title: { type: String, default: ""},
      titleSub:{type:String,default:''}
    },
  data() {
    return {
      blulights: [1,2,3,4,5,6,7,8,9,10,11,12],
      userEmail:'',
      formMessage:'',
      usedForm:false
    };
  },
  mounted() {
    //this.cursorAnim();
     //console.log(window.screen.height,window.screen.width)
    // this.userEmail = window.screen.height+' -- '+ window.screen.width
  },
  methods: {
    cursorAnim: () => {
      let curs = document.querySelector(".cursor");
      var pauseOn= false
      document.querySelector(".sec.sec-01").addEventListener("mousemove", (e) => {
        if(pauseOn) return false;
          let x = e.pageX;
          let y = e.pageY;
          curs.style.left = x - 150 + "px";
          curs.style.top = y - 200 + "px";
            curs.style.opacity = "1";
        
        });
        document.querySelector(".sec.sec-01").addEventListener("mouseleave", () => {
          // curs.style.opacity = "0";
        });
        document.querySelector(".sec.sec-01").addEventListener("click", () => {
          // curs.style.opacity = "0";
          pauseOn= pauseOn?false:true;
        });
    },
    submitUserEmail:function(){
      if(this.usedForm) return false;
      document.querySelector('#userEmail').classList.remove('has-error')
      if(!helpers.validateEmail(this.userEmail)){
          document.querySelector('#userEmail').classList.add('has-error')
        return false
      }else{
          var data = JSON.stringify({ email: this.userEmail,"data": { "message":'Get Early Access!'} });
          var config = {
            method: 'post', url: 'https://api.mailmodo.com/api/v1/at/c/rWpob6EHX2/d9ac7c96-4136-5708-ba67-14c9e26c2c0a',
            headers: { 'Content-Type': 'application/json'},
            data : data
            };
          let self=this;
          axios(config).then(function (response) {
              self.userEmail=""
              self.usedForm=true
              self.formMessage = 'Submitted Successfully'
              console.log(JSON.stringify(response.data))
          }).catch(function (error) {
              console.log(error);
          });
      }
    }
  },
};
</script>
